// Mock data para TSW Info - Assistência Técnica em Osasco

export const companyInfo = {
  name: "Tsw Info",
  slogan: "Soluções em Informática",
  whatsapp: "11947310730",
  whatsappFormatted: "(11) 94731-0730",
  email: "contato@tswinfo.com.br",
  address: "Rua Salem Bechara, 185",
  city: "Osasco",
  neighborhood: "Centro",
  state: "SP",
  fullAddress: "Rua Salem Bechara, 185 - Centro, Osasco - SP",
  hours: "10:00 às 18:00h",
  instagram: "tswinfo.osasco",
  instagramUrl: "https://instagram.com/tswinfo.osasco",
  logo: "https://customer-assets.emergentagent.com/job_tech-repair-osasco/artifacts/29lbqf0j_WhatsApp%20Image%202026-01-14%20at%2017.19.57.jpeg"
};

export const differentials = [
  {
    id: 1,
    title: "Atendimento Rápido",
    description: "Tempo médio de reparo de apenas 2 horas",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Garantia de 3 Meses",
    description: "Todos os serviços com garantia de 3 meses",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Peças de Qualidade",
    description: "Peças originais e compatíveis de alta qualidade",
    icon: "Award"
  },
  {
    id: 4,
    title: "Técnicos Especializados",
    description: "Profissionais certificados e experientes",
    icon: "Users"
  }
];

export const services = [
  {
    id: 1,
    name: "Troca de Tela",
    description: "Substituição de telas quebradas ou com defeito",
    icon: "Smartphone"
  },
  {
    id: 2,
    name: "Troca de Bateria",
    description: "Substituição de baterias viciadas ou inchadas",
    icon: "Battery"
  },
  {
    id: 3,
    name: "Reparo de Placa",
    description: "Conserto de placas-mãe e componentes internos",
    icon: "Cpu"
  },
  {
    id: 4,
    name: "Aparelho Não Liga",
    description: "Diagnóstico e reparo de dispositivos que não ligam",
    icon: "Power"
  },
  {
    id: 5,
    name: "Contato com Água",
    description: "Recuperação de aparelhos molhados ou oxidados",
    icon: "Droplets"
  },
  {
    id: 6,
    name: "Upgrade",
    description: "Melhoria de performance com mais memória e SSD",
    icon: "TrendingUp"
  }
];

export const brands = [
  {
    id: "iphone",
    name: "iPhone",
    slug: "assistencia-tecnica-iphone-osasco",
    description: "Assistência técnica especializada em iPhone em Osasco",
    metaTitle: "Assistência Técnica iPhone Osasco | Conserto iPhone - Tsw Info",
    metaDescription: "Assistência técnica iPhone em Osasco. Troca de tela, bateria, reparo de placa. Atendimento em 2h, garantia 3 meses. Ligue: (11) 94731-0730",
    heroTitle: "Assistência Técnica iPhone em Osasco",
    heroSubtitle: "Conserto rápido e seguro para todos os modelos de iPhone",
    models: ["iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15", "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14", "iPhone 13", "iPhone 12", "iPhone 11", "iPhone SE"],
    color: "#2B3990"
  },
  {
    id: "samsung",
    name: "Samsung",
    slug: "assistencia-tecnica-samsung-osasco",
    description: "Assistência técnica especializada em Samsung em Osasco",
    metaTitle: "Assistência Técnica Samsung Osasco | Conserto Samsung - Tsw Info",
    metaDescription: "Assistência técnica Samsung em Osasco. Troca de tela, bateria, reparo de placa. Atendimento em 2h, garantia 3 meses. Ligue: (11) 94731-0730",
    heroTitle: "Assistência Técnica Samsung em Osasco",
    heroSubtitle: "Conserto especializado para celulares e tablets Samsung",
    models: ["Galaxy S24 Ultra", "Galaxy S24+", "Galaxy S24", "Galaxy S23", "Galaxy Z Fold", "Galaxy Z Flip", "Galaxy A54", "Galaxy A34", "Galaxy Tab"],
    color: "#1428A0"
  },
  {
    id: "macbook",
    name: "MacBook",
    slug: "assistencia-tecnica-macbook-osasco",
    description: "Assistência técnica especializada em MacBook em Osasco",
    metaTitle: "Assistência Técnica MacBook Osasco | Conserto MacBook - Tsw Info",
    metaDescription: "Assistência técnica MacBook em Osasco. Troca de tela, bateria, reparo de placa. Técnicos especializados, garantia 3 meses. Ligue: (11) 94731-0730",
    heroTitle: "Assistência Técnica MacBook em Osasco",
    heroSubtitle: "Manutenção profissional para MacBook Air e MacBook Pro",
    models: ["MacBook Pro 16\"", "MacBook Pro 14\"", "MacBook Pro 13\"", "MacBook Air M3", "MacBook Air M2", "MacBook Air M1"],
    color: "#333333"
  },
  {
    id: "notebook",
    name: "Notebook",
    slug: "assistencia-tecnica-notebook-osasco",
    description: "Assistência técnica especializada em Notebook em Osasco",
    metaTitle: "Assistência Técnica Notebook Osasco | Conserto Notebook - Tsw Info",
    metaDescription: "Assistência técnica Notebook em Osasco. Todas as marcas: Dell, HP, Lenovo, Acer, Asus. Upgrade SSD e memória. Ligue: (11) 94731-0730",
    heroTitle: "Assistência Técnica Notebook em Osasco",
    heroSubtitle: "Conserto e manutenção para todas as marcas de notebooks",
    models: ["Dell", "HP", "Lenovo", "Acer", "Asus", "Samsung", "Positivo", "Vaio"],
    color: "#0078D4"
  },
  {
    id: "motorola",
    name: "Motorola",
    slug: "assistencia-tecnica-motorola-osasco",
    description: "Assistência técnica especializada em Motorola em Osasco",
    metaTitle: "Assistência Técnica Motorola Osasco | Conserto Motorola - Tsw Info",
    metaDescription: "Assistência técnica Motorola em Osasco. Troca de tela, bateria, reparo de placa. Moto G, Moto Edge. Ligue: (11) 94731-0730",
    heroTitle: "Assistência Técnica Motorola em Osasco",
    heroSubtitle: "Reparo especializado para toda linha Motorola",
    models: ["Moto Edge 40", "Moto Edge 30", "Moto G84", "Moto G73", "Moto G54", "Moto G34", "Moto E"],
    color: "#5C92FA"
  },
  {
    id: "xiaomi",
    name: "Xiaomi",
    slug: "assistencia-tecnica-xiaomi-osasco",
    description: "Assistência técnica especializada em Xiaomi em Osasco",
    metaTitle: "Assistência Técnica Xiaomi Osasco | Conserto Xiaomi - Tsw Info",
    metaDescription: "Assistência técnica Xiaomi em Osasco. Troca de tela, bateria, reparo de placa. Redmi, POCO, Mi. Ligue: (11) 94731-0730",
    heroTitle: "Assistência Técnica Xiaomi em Osasco",
    heroSubtitle: "Conserto profissional para Xiaomi, Redmi e POCO",
    models: ["Xiaomi 14", "Xiaomi 13", "Redmi Note 13", "Redmi Note 12", "POCO X6", "POCO F5", "Redmi 13C"],
    color: "#FF6900"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    text: "Excelente atendimento! Troquei a tela do meu iPhone em menos de 2 horas. Muito satisfeito!",
    rating: 5,
    service: "Troca de Tela iPhone"
  },
  {
    id: 2,
    name: "Maria Santos",
    text: "Profissionais muito competentes. Meu notebook voltou a funcionar perfeitamente após o upgrade de SSD.",
    rating: 5,
    service: "Upgrade Notebook"
  },
  {
    id: 3,
    name: "João Oliveira",
    text: "Atendimento rápido e preço justo. Recomendo a todos que precisam de assistência técnica em Osasco.",
    rating: 5,
    service: "Reparo Samsung"
  }
];

export const faqs = [
  {
    question: "Qual o tempo médio de reparo?",
    answer: "O tempo médio de reparo é de aproximadamente 2 horas, dependendo do serviço. Em casos mais complexos, informamos o prazo no momento do orçamento."
  },
  {
    question: "Vocês trabalham com peças originais?",
    answer: "Sim! Trabalhamos com peças originais e compatíveis de alta qualidade. Você pode escolher a opção que melhor atende suas necessidades."
  },
  {
    question: "Qual a garantia dos serviços?",
    answer: "Todos os nossos serviços possuem garantia de 3 meses, tanto para a mão de obra quanto para as peças utilizadas."
  },
  {
    question: "Vocês fazem orçamento gratuito?",
    answer: "Sim, realizamos orçamento gratuito e sem compromisso. Traga seu aparelho para análise!"
  },
  {
    question: "Qual o horário de funcionamento?",
    answer: "Funcionamos de segunda a sexta-feira, das 10:00 às 18:00h."
  },
  {
    question: "Onde fica a loja?",
    answer: "Estamos localizados na Rua Salem Bechara, 185 - Centro, Osasco - SP. Fácil acesso e estacionamento próximo."
  }
];